import errorCodes from './constant/errorCodes'
import {isEmpty, cloneDeep, filter, isNil} from 'lodash'
import axios from 'axios'
import pageRoutes from './constant/pageRoutes'
import settings from '@/libs/constant/settings'
import constants from './constant/constants'
const countrydata = require('countrydata');
import {API_BASE_URL, logoutCall} from '@/libs/api/api'
export const WEB_BASE_URL = process.env.VUE_APP_WEB_BASE_URL
import router from '../router'
import { Message } from 'element-ui';
import store from '@/store/index.js'
export function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

/*
* errorHandler function receives an error object and a callback,
* matches the appropriate error and returns the message to display.
* */
export function errorHandler (object, callback, switchRouteCallback) {
	switch (object.code){
		case errorCodes.NOT_FOUND.code:
			switchRouteCallback && switchRouteCallback();
			return window.i18next.t(capitalizeFirstLetter(object.message).replaceAll('_', ' ') || errorCodes.NOT_FOUND.customMessage);
		case errorCodes.INTERNAL.code:
			return window.i18next.t(errorCodes.INTERNAL.customMessage);
		case errorCodes.UNAUTHORIZED.code:
			if (object.message === 'authorization_token_required' || object.message === 'authorization_token_invalid') callback && callback();
			else permissionsErrorHandler()
			return window.i18next.t(errorCodes.UNAUTHORIZED.customMessage);
		case errorCodes.INVALID_LOGIN.code:
			return window.i18next.t(errorCodes.INVALID_LOGIN.customMessage);
		case errorCodes.NOT_IMPLEMENTED.code:
			return window.i18next.t(errorCodes.NOT_IMPLEMENTED.customMessage);
		case errorCodes.INVALID_INPUT.code:
			return window.i18next.t(object.message || errorCodes.INVALID_INPUT.customMessage);
		case errorCodes.NOT_ALLOWED.code:
			return window.i18next.t(capitalizeFirstLetter(object.message).replaceAll('_',' ') || errorCodes.NOT_ALLOWED.customMessage);
		case errorCodes.NO_ACCESS.code:
			return window.i18next.t(errorCodes.NO_ACCESS.customMessage);
		case errorCodes.ALREADY_EXISTS.code:
			return window.i18next.t(object.message || errorCodes.ALREADY_EXISTS.customMessage);
		case errorCodes.SIZE_LIMIT.code:
			return window.i18next.t(errorCodes.SIZE_LIMIT.customMessage);
		case errorCodes.EMAIL_ALREADY_VERIFIED.code:
			return window.i18next.t(errorCodes.EMAIL_ALREADY_VERIFIED.customMessage);
		case errorCodes.EMAIL_ALREADY_REGISTERED.code:
			return window.i18next.t(errorCodes.EMAIL_ALREADY_REGISTERED.customMessage)
		case errorCodes.RATE_LIMIT.code:
			return window.i18next.t(errorCodes.RATE_LIMIT.customMessage);
		case errorCodes.STRIPE_ERROR.code:
			return object.message;
		case errorCodes.PERMISSION_REVOKED.code:
			return window.i18next.t(object.message || errorCodes.PERMISSION_REVOKED.customMessage);
		default:
			return window.i18next.t(errorCodes.UNKNOWN_ERROR.customMessage)
	}
}
/**
 * to switch route if resource doesnot exists
 * @param {*} route 
 */
export function routeErrorHandler (route) {
	if (!isEmpty(route)) router.replace(route).catch(() => {})
}
/*
* message function receives
* @context of scope from where it is called,
* @type of the message(error, success...etc) and,
* @message to display.
* */
export function message(context, type, message, duration) {
	context.$message({
		duration: duration || 3000,
		showClose: true,
		message: window.i18next.t(message),
		type: type
	});
}

/*
* logout function receives the @context,
* clears the sessionStroage and route the user
* to sign-in page.
* */
export function logout(context) {
	let device_id = localStorage.getItem('device_id') ? localStorage.getItem('device_id') : ''
	logoutCall({device_id}).catch(error => error)
	context.$store.dispatch('clearInformationPortalStore')
	let lang = localStorage.getItem('lang')
	localStorage.clear();
	localStorage.setItem('lang', lang || settings.LOCIZE.LANGUAGE.ENGLISH_GB)
	context.$router.push(pageRoutes.signIn).catch(() => {})
}

/*
* loader function receives
* @context of scope from where it is called, and
* a boolean value to indicated to start and stop
* the loader.
* */
export function loader(context, isLoaderStart){
	let loading;
	loading = context.$loading({
		lock: true,
		text: 'Loading',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.1)'
	});
	if(!isLoaderStart){
		loading.close()
	}
}
/*
* openTermAndPrivacy() receive a page name to
* open.
* */
export function openTermAndPrivacy(page, isSameTab){
	if(isSameTab){
		switch (page){
			case 'term':
				window.location.href = `${WEB_BASE_URL}${pageRoutes.term}`;
				return;
			case 'privacy':
				window.location.href = `${WEB_BASE_URL}${pageRoutes.privacy}`;
				return;
			case 'PB':
				window.location.href = `${WEB_BASE_URL}${pageRoutes.prohibitedBusiness}`;
				return;
		}
	}else{
		switch (page){
			case 'term':
				window.open(`${WEB_BASE_URL}${pageRoutes.term}`);
				return;
			case 'privacy':
				window.open(`${WEB_BASE_URL}${pageRoutes.privacy}`);
				return;
			case 'PB':
				window.open(`${WEB_BASE_URL}${pageRoutes.prohibitedBusiness}`);
				return;
		}
	}
}

/*
* getNodeEnv() receive a
* @env: environment variable value
* and returns the desired string
* according to the received value
* */
export function getNodeEnv(env) {
	switch (env){
		case settings.ENV.DEVELOPMENT || 'dev' :
			return settings.ENV.DEVELOPMENT
		case settings.ENV.STAGING :
			return settings.ENV.STAGING
		case settings.ENV.PRODUCTION || 'prod' :
			return settings.ENV.PRODUCTION
		default:
			return settings.ENV.DEVELOPMENT
	}
}

/*
 * urlValidation() receive a
 * @data: url/website value
 * and returns true/false after
 * validate url.
 * */
export function urlValidation (data) {
	// eslint-disable-next-line
	return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,5})?(\/.*)?$/.test(data);
}

/*
 * urlValidation() receive a
 * @data: url/website value
 * and returns true/false after
 * validate url.
 * */
export function getCountryByCode(code){
	if (code) {
		return countrydata.alpha2[code].iso3166.name
	}
}
/*
 * getImageUrl() receive a
 * @image: avatar name of S3
 * and returns a url to download
 * the image.
 * */
export function getImageUrl(image) {
	return `${API_BASE_URL}/accounts/files/${image}?auth=${localStorage.getItem('accuraAuthToken')}`
}

/*
 * onError() receive a
 * @e: event object value,
 * @isUser: boolean value
 * which sets the placeholder image
 * in case of fail image load.
 * */
export function onError(e, isUser) {
	let avatarURL = require('../assets/images/author_placeholder.png');
	if(isUser){
		avatarURL = require('../assets/images/img_avatar.png');
	}
	if (e.target.src !== avatarURL) {
		e.target.src = avatarURL;
	}
}
export function getAuthors (authors) {
	if(isEmpty(authors) || authors.length < 0) return []
	let unique = [...new Set(authors.map(item => item.author && item.author.name))]
	return unique.join(', ')
  }

export function getCapitalName (name) {
	return name.charAt(0).toUpperCase() + name.slice(1)
}
  
export function filterArray (array) {
	let result = array.map(item => item._id)
	return result
}

export function checkIfAdmin() {
	if (localStorage.getItem('accura_ad') === constants.ROLE.ADMIN) {
		return true
	}
	return false
}

export function copyText (id) {
	var copyText = document.getElementById(id);
	copyText.select()
	document.execCommand("copy")
	window.getSelection().removeAllRanges()
}

export function navigateTo (id) {
	let element = document.getElementById(id)
	if (element !== null) element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
}

export function copyElement (value) {
	const el = document.createElement('textarea');
	el.value = value;
	el.setAttribute('readonly', '');
	el.style.position = 'absolute';
	el.style.left = '-9999px';
	document.body.appendChild(el);
	el.select();
	document.execCommand('copy');
	document.body.removeChild(el);
}
export function getAppliedFilters (selectedMetaFilters) {
	let filtersToApply = {}
	if (!isEmpty(selectedMetaFilters)) {
		if (selectedMetaFilters.city && selectedMetaFilters.city.length > 0) {
			filtersToApply.cities = selectedMetaFilters.city
		}
		if (selectedMetaFilters.url && selectedMetaFilters.url.length > 0) {
			filtersToApply.urls = selectedMetaFilters.url
		}
		if (selectedMetaFilters.name && selectedMetaFilters.name.length > 0) {
			filtersToApply.names = selectedMetaFilters.name
		}
		if (selectedMetaFilters.country && selectedMetaFilters.country.length > 0) {
			filtersToApply.countries = selectedMetaFilters.country
		}
		if (selectedMetaFilters.publisher && selectedMetaFilters.publisher.length > 0) {
			filtersToApply.publishers = selectedMetaFilters.publisher
		}
		if (selectedMetaFilters.language && selectedMetaFilters.language.length > 0) {
			filtersToApply.languages = selectedMetaFilters.language
		}
		if (selectedMetaFilters.first_name && selectedMetaFilters.first_name.length > 0) {
			filtersToApply.first_names = selectedMetaFilters.first_name
		}
		if (selectedMetaFilters.last_name && selectedMetaFilters.last_name.length > 0) {
			filtersToApply.last_names = selectedMetaFilters.last_name
		}
		if (selectedMetaFilters.middle_name && selectedMetaFilters.middle_name.length > 0) {
			filtersToApply.middle_names = selectedMetaFilters.middle_name
		}
		if (selectedMetaFilters.short_description && selectedMetaFilters.short_description.length > 0) {
			filtersToApply.short_descriptions = selectedMetaFilters.short_description
		}
		if (selectedMetaFilters.biography && selectedMetaFilters.biography.length > 0) {
			filtersToApply.biographies = selectedMetaFilters.biography
		}
		if (selectedMetaFilters.admin && selectedMetaFilters.admin.length > 0) {
			filtersToApply.admins = selectedMetaFilters.admin
		}
		if (selectedMetaFilters.publication && selectedMetaFilters.publication.length > 0) {
			filtersToApply.publications = selectedMetaFilters.publication
		}
		if (selectedMetaFilters.title && selectedMetaFilters.title.length > 0) {
			filtersToApply.titles = selectedMetaFilters.title
		}
		if (selectedMetaFilters.sub_title && selectedMetaFilters.sub_title.length > 0) {
			filtersToApply.sub_titles = selectedMetaFilters.sub_title
		}
		if (selectedMetaFilters.description && selectedMetaFilters.description.length > 0) {
			filtersToApply.descriptions = selectedMetaFilters.description
		}
		if (selectedMetaFilters.authors && selectedMetaFilters.authors.length > 0) {
			filtersToApply.authors = selectedMetaFilters.authors
		}
		if (selectedMetaFilters.pub_date && selectedMetaFilters.pub_date.length > 0) {
			filtersToApply.pub_dates = selectedMetaFilters.pub_date
		}
		if (selectedMetaFilters.email && selectedMetaFilters.email.length > 0) {
			filtersToApply.emails = selectedMetaFilters.email
		}
		if (selectedMetaFilters.article_count && !isNil(selectedMetaFilters.article_count)) {
			filtersToApply.article_count = parseInt(selectedMetaFilters.article_count)
		}
		if (selectedMetaFilters.author_count && !isNil(selectedMetaFilters.author_count)) {
			filtersToApply.author_count = parseInt(selectedMetaFilters.author_count)
		}
		if (selectedMetaFilters.publication_count && !isNil(selectedMetaFilters.publication_count)) {
			filtersToApply.publication_count = parseInt(selectedMetaFilters.publication_count)
		}
	}
	return filtersToApply
}

/**
 * to get the catalog Id of the user
 */
export function getCatalogId () {
	if (localStorage.getItem('catalogs') !== null && localStorage.getItem('catalogs') !== undefined) {
	return JSON.parse(localStorage.getItem('catalogs')).length > 0
		? ((JSON.parse(localStorage.getItem('catalogs'))[0].id) || (JSON.parse(localStorage.getItem('catalogs'))[0]._id))
		: ''
	}
}

export function getCatalogIdByUserId (selectedAccount) {
	if (localStorage.getItem('catalogs') !== null && localStorage.getItem('catalogs') !== undefined && !isEmpty(selectedAccount)) {
		const catalogs = JSON.parse(localStorage.getItem('catalogs')) || []
		const [activeCatalog] = filter(catalogs, (catalog) => (selectedAccount.id === catalog.user) || (selectedAccount._id === catalog.organisation))
		return !isEmpty(activeCatalog) ? activeCatalog.id : ''
	}
	return ''
}

/**
 * to convert the count into (k) notations
 */
export function getNewCount (num) {
	let count = parseInt(num)
	if(count > 999 && count < 1000000){
        count = (count/1000).toFixed(1) + 'K'; // convert to K for number from > 1000 < 1 million 
    }else if(count > 1000000){
        count = (count/1000000).toFixed(1) + 'M'; // convert to M for number from > 1 million 
	}
	return count
}

// update the page title
export function updatePageTitle (title) {
	document.title = !isEmpty(title) ? title : 'Accura'
}

/*
 * socialShare() method shares link or selected text
 * on the selected platform.
 * */
export function socialShare (shareTo, selectedArticle, selectedText) {
  let textToShare = {}
  switch (shareTo.platform) {
	case constants.PLATFORMS.FACEBOOK:
		if (selectedText !== null) {
			window.open(`https://www.facebook.com/dialog/share?app_id=${settings.FACEBOOK_APP_ID}&display=popup&href=${selectedArticle.url}&quote=${selectedText}&redirect_uri=https://www.facebook.com/`, '_blank')
			break
		}
		window.open(`https://www.facebook.com/dialog/share?app_id=${settings.FACEBOOK_APP_ID}&display=popup&href=${selectedArticle.url}&redirect_uri=https://www.facebook.com/`, '_blank')
	break
	case constants.PLATFORMS.TWITTER:
		if (selectedText !== null) {
			window.open(`https://twitter.com/intent/tweet?text=${selectedText}%0D%0A&url=${selectedArticle.url}`, 'twitter-popup', '_blank')
			break
		}
		window.open(`https://twitter.com/intent/tweet?url=${selectedArticle.url}`, 'twitter-popup')
	break
	case constants.PLATFORMS.LINKEDIN:
		window.open(`http://www.linkedin.com/shareArticle?mini=true&url=${selectedArticle.url}&source=accura.onl`, '', 'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0')
	break
	case constants.PLATFORMS.FLIPBOARD:
		window.open(`https://share.flipboard.com/bookmarklet/popout?v=2&title=${selectedArticle.title}&url=${selectedArticle.url}`, '_blank')
	break
	case constants.PLATFORMS.SLACK:
		textToShare.text = selectedArticle.url
		axios({
			method: 'POST',
			url: process.env.VUE_APP_SLACK_URI,
			data: JSON.stringify(textToShare)
		})
	break
	case constants.PLATFORMS.REDDIT:
		window.open(`https://reddit.com/submit?url=${selectedArticle.url}&title=${selectedArticle.title}`, '_blank')
	break
	case constants.PLATFORMS.EMAIL:
		window.open(`mailto:?subject=&body=${selectedArticle.url}`, '_blank')
		// window.location.href = `mailto:?subject=&body=${selectedArticle.url}`
	break
	case constants.PLATFORMS.PARLER:
		window.open(`https://parler.com/new-post?message=${selectedArticle.title}&url=${selectedArticle.url}`, '_blank')
	break
  }
}

/**
 * to check if date is in one
 * digit to append o to it
 */
export function checkZero (data) {
  // if length = 1 append 0
  if (data.toString().length === 1) {
	data = '0' + data
  }
  return data
}

export function getMetaFieldsToShare (metaField, article, isTrue) {
  let selectedArticle = cloneDeep(article)
  switch (metaField) {
	case 'TITLE':
		if (selectedArticle && selectedArticle.title && selectedArticle.title !== '' && selectedArticle.title !== undefined) {
			return selectedArticle.title || ''
		} return ''
	case 'SUB_TITLE':
		if (selectedArticle && selectedArticle.sub_title && selectedArticle.sub_title !== '' && selectedArticle.sub_title !== undefined) {
			return selectedArticle.sub_title || ''
		} return ''
	case 'DESCRIPTION':
		if (selectedArticle && selectedArticle.description && selectedArticle.description !== '' && selectedArticle.description !== undefined) {
			return selectedArticle.description || ''
		} return ''
	case 'PUB_DATE':
		if (selectedArticle && selectedArticle.pub_date && selectedArticle.pub_date !== '' && selectedArticle.pub_date !== undefined) {
			return selectedArticle.pub_date || ''
		} return ''
	case 'PUBLISHER':
		if (selectedArticle && selectedArticle.publisher && !isEmpty(selectedArticle.publisher)) {
			return selectedArticle.publisher.name || ''
		} return ''
	case 'PUBLICATION':
		if (!isEmpty(selectedArticle && selectedArticle.publication)) {
			return selectedArticle.publication.name
		} return ''
	case 'KEYWORD':
		if (selectedArticle && selectedArticle.tags && !isEmpty(selectedArticle.tags)) {
			let unique = [...new Set(selectedArticle.tags.map(item => {
			if (isTrue) return item && item.name && `%23${item.name.charAt(0).toUpperCase() + item.name.slice(1)}`
			return item && item.name && `#${item.name}`
			}))]
			return unique.join(', ')
		} return ''
	case 'AUTHORS':
		if (!isEmpty(selectedArticle.authors)) {
			let author = ''
			author = selectedArticle.authors[0] && selectedArticle.authors[0].name
			if (author !== '' && author !== null && author !== undefined) {
			author = article.authors.length > 1 ? `${capitaliseAuthor(author)} et al` : `${capitaliseAuthor(author)}`
			} else {
			author = ''
			}
			return author
		} return ''
  }
}
export function capitaliseAuthor (author) {
  return author.split(' ').map(a => a.charAt(0).toUpperCase() + a.slice(1).toLowerCase()).join(' ')
}
/**
 * to open a url 
 * @param {*} url 
 * @param {*} toOpenInSameTab in same tab or not(true/ false)
 */
export function openInNewTab (url, toOpenInSameTab) {
	if (url !== null && url !== undefined && url !== '') {
		window.open(url, toOpenInSameTab ? '_self' :'_blank')
	}
}
export function removeProtocol (url) {
	let website = url
	if (website.includes('https://')) website = website.replace('https://', ' ').trim()       
	else if (website.includes('http://')) website = website.replace('http://', ' ').trim()
	return website
}

export function getDate (date, isOnlyDate) {
  if (date !== undefined && date !== null) {
    let d = new Date(date)
	let dateToSend = ''
	if (isOnlyDate) {
		dateToSend = ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + d.getFullYear()
	} else {
		dateToSend = ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + d.getFullYear() + ' ' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2)
	}
	return dateToSend
   }
}

/**
 * before avatar image
 * @param {*} file 
 * @returns 
 */
export function beforeAvatarUpload (file) {
	// image format validation
	const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
	// image size validation
	const isLt2M = file.size / 1024 / 1024 < 2;
	if (!isJPG) {
		Message.error(window.i18next.t('Image format is not supported'));
	}

	if (!isLt2M) {
		Message.error('Image size can not exceed 2MB!');
	}

	// this.compressImageBeforeUpload(file)

	return isJPG && isLt2M;
}

/**
 * send truncated twitter url
 */
export function getTruncatedTwitterUrl (url, type) {
	let outputUrl = url
	if (url !== '' && !isNil(url)) {
		switch (type) {
			case 'TWITTER':
				outputUrl = url.replace(/http(?:s)?:\/\/(?:www\.)?twitter\.com\//, '')
			break;
			case 'PARLER':
				outputUrl = url.replace(/http(?:s)?:\/\/(?:www\.)?parler\.com\//, '')
			break;
		} 
		outputUrl = `@${outputUrl}`
	}
	return outputUrl;
}

const permissionsErrorHandler = () => {
	//
	store.dispatch('setRefreshUserProfileAndPermissions', true)
	router.push({name: pageRoutes.organisationOverview, params: {id: store.getters.getSelectedAccount.id}}).catch(() => {})
}